module.exports = __webpack_public_path__ + "static/media/Google-calendar.67c66463.svg";